import React, { useEffect } from 'react'

import { readDevices } from '../helpers'
import CardDeck from './CardDeck'
import TableCard from './TableCard'
import { useAppSelector } from '../../../hooks/redux'

interface Device {
    lastSeenStatus?: string
    oilAlarm?: boolean
}

interface IndexDevicesProps {
    filterMonitored: boolean | null
}

/**
 * Devices list page.
 *
 * Renders the dashboard summary cards and the data table for the
 * active monitoring filter.
 */
const IndexDevices = ({ filterMonitored }: IndexDevicesProps) => {
    const devices = useAppSelector(state => state.devices.data) as Device[]

    const loadData = (filters: boolean | null): void => {
        readDevices(filters)
    }

    useEffect(() => {
        loadData(filterMonitored)
    }, [filterMonitored])

    const devicesCount = devices.length
    const failureCount = devices.filter(device => device.lastSeenStatus !== 'ok').length
    const oilAlarmCount = devices.filter(device => device.oilAlarm === true).length

    return (
        <div className="container">
            <CardDeck
                devicesCount={devicesCount}
                failureCount={failureCount}
                oilAlarmCount={oilAlarmCount}
            />
            <TableCard
                filterMonitored={filterMonitored}
                reloadData={() => loadData(filterMonitored)}
            />
        </div>
    )
}

export default IndexDevices
